<script lang="ts" setup>
import type { IButtonSize, IButtonVariant } from "@/types"

interface ButtonProps {
  variant?: IButtonVariant
  size?: IButtonSize
  disabled?: boolean
}

withDefaults(defineProps<ButtonProps>(), {
  variant: "primary",
  size: "default",
  disabled: false,
})
</script>

<template>
  <button
    class="gpx-button"
    :class="[`gpx-button_${variant}`, `gpx-button-${size}`]"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>

<style scoped lang="postcss">
@reference "../../assets/styles.css";

.gpx-button {
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;

  @apply rounded-lg font-comfortaa font-bold text-base py-2 px-4 border border-transparent bg-transparent gap-2 text-center whitespace-nowrap no-underline flex items-center justify-center;
}

a.gpx-button {
  text-decoration: none;
}

.gpx-button-lg {
  padding: 0.5rem 1.5rem;
  font-size: 1.25rem;
  gap: 1rem;
}

.gpx-button_flat {
  @apply text-gray-700;
}

.gpx-button_flat:hover {
  @apply text-gray-400;
}

.gpx-button_danger {
  @apply bg-danger text-gray-100;
}

.gpx-button_danger:hover {
  @apply text-danger bg-gray-100;
}

.gpx-button_primary {
  background: var(--template-primary-colour-preview);
  color: var(--template-primary-button-text-preview);
  border-color: var(--template-primary-colour-preview);
}

.gpx-button_primary:hover {
  @apply bg-white;

  color: var(--template-primary-colour-preview);
  border-color: var(--template-primary-colour-preview);
}

.gpx-button_icon {
  padding: 0.5rem 0.675rem;
}

.gpx-button_tertiary,
.gpx-button_icon {
  @apply bg-transparent;

  color: var(--template-primary-colour-preview);
  border-color: var(--template-primary-colour-preview);
}

.gpx-button_tertiary:hover,
.gpx-button_icon:hover {
  @apply text-white;

  background-color: var(--template-primary-colour-preview);
  border-color: var(--template-primary-colour-preview);
}

.gpx-button_secondary {
  background: var(--template-secondary-colour-preview);
  color: var(--template-secondary-button-text-preview);
  border-color: var(--template-secondary-colour-preview);
}

.gpx-button_secondary:hover {
  @apply bg-white;

  color: var(--template-primary-colour-preview);
  border-color: var(--template-secondary-colour-preview);
}

.gpx-button:disabled,
.gpx-button:disabled:hover {
  @apply bg-gray-400 border-gray-400 border text-gray-200 cursor-not-allowed;
}
</style>
